export class ChargingParkSubscriptionDto {
  parkOwnerName: string
  parkOwnerStripeAccountId: string
  StripeCustomerId: string
  stripePriceId: string
  stripeSubscriptionId: string

  name: string
  company: string
  email: string
  street: string
  housenumber: string
  line1: string
  line2: string
  postalCode: string
  city: string

  userId: string

  setupIntentId: string
  stripeClientSecret: string
  paymentMethodId: string
  pricingId: number

  url: string;
}
